import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const ALLOWED_PATHS = ["/reset-password", "/backoffice/reset-password"];

/**
 * When a user signed in with an admin-issued temporary password,
 * profiles.must_change_password is true. This guard force-redirects
 * them to /reset-password until they set a new password (which clears
 * the flag via the clear_must_change_password RPC in ResetPassword).
 */
export const MustChangePasswordGuard = () => {
  const { user, mustChangePassword, isLoading, isAdminLoading } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (isLoading || isAdminLoading) return;
    if (!user || !mustChangePassword) return;
    if (ALLOWED_PATHS.some((p) => pathname.startsWith(p))) return;
    navigate("/reset-password?force=1", { replace: true });
  }, [user, mustChangePassword, isLoading, isAdminLoading, pathname, navigate]);

  return null;
};

export default MustChangePasswordGuard;
